import React from 'react';
import Link from 'gatsby-link';

import diamond from '../../components/img/diamond.svg';

const Header = () => (
  <header className="header">
    <div className="header__row">
      <section className="header__section header__section--align-start">
        <span className="header__title">
          <img className="DiamondIcon" src={diamond} alt="Diamant" />
        </span>
      </section>
    </div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/layout/Header.js